
import analytics from '@/mixins.js/analytics'

export default {
  mixins: [analytics],
  data () {
    return {
      expanded: false
    }
  },
  methods: {
    toggleTerms () {
      this.expanded = !this.expanded
      this.trackEvent('Terms', this.expanded ? 'Collapse terms' : 'Expand terms')
    }
  }
}
